import Component from "gia/Component";
import Channels from "../base/channels";

export default class Module extends Component {
  constructor(element) {
    super(element);
    this.ref = {};
  }

  mount() {
    this.DOM = {};
    this.DOM.view = this.element;
    this.DOM.btnAdd = this.ref.btnAdd[0];

    this.DOM.btnAdd.addEventListener("click", () => {
      Channels.emit("addtocart::click");
    });
  }

  unmount() {}
}
